import { isNilOrEmpty } from './is-nil-or-empty';

/**
 * Case insensitive, type safe, comparision of string
 * If contains text is nil or empty result is true
 *
 * Example: textContains('MY STRING', 'str') => true
 * Example: textContains('MY STRING', '') => true
 * Example: textContains('MY STRING') => true
 * Example: textContains('MY STRING', 'X') => false
 *
 * @param targetText Text to check if it includes contains text
 * @param testText Check if input text includes contains text
 */
export function textContains(targetText: string, testText: string) {
  if (isNilOrEmpty(testText)) {
    return true;
  }

  if (isNilOrEmpty(targetText)) {
    targetText = '';
  }

  return targetText.toLowerCase().includes(testText.toString().toLowerCase());
}
